import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import { gt } from "./i18n/gt";
import "@/styles/fonts.css";
import "@/styles/global.css";
// Kundenfeedback 24.10.2026 (XX): eine Pillen-/Umschalter-Optik für die ganze Anwendung.
import "@/styles/pills.css";
// Kundenfeedback 16.10.2026 Teil 2 (XI): gemeinsame Flächen-Optik der Akten-Unterseiten.
import "@/styles/caseSurface.css";
import "@/styles/questionnaire.css";
import "@/styles/questionnaire-step.css";
import "@/styles/questionnaire-shell.css";
import "@/styles/questionnaire-done.css";
import "flag-icons/css/flag-icons.min.css";
import router from "./router";
import { createPinia } from "pinia";
import arrowScroll from "./directives/arrowScroll";

const app = createApp(App);

if (process.env.NODE_ENV === "production") {
  (window as any).__VUE_DEVTOOLS_GLOBAL_HOOK__ = undefined;
}

const pinia = createPinia();
app.use(pinia);

app.use(vuetify);
app.use(i18n);

// Tastatur-Scrollen (Pfeiltasten/Bild auf-ab/Pos1/Ende) in Scrollbereichen (Issue #642)
app.directive("arrow-scroll", arrowScroll);

// Global German-source translate helper: usable as `$gt('...')` in templates
// and `this.$gt('...')` in Options-API components.
app.config.globalProperties.$gt = gt;

app.use(router);
app.mount("#app");
